<template>
  <div>
    <!-- to remove time picker -set type - timestamp -->
    <date-picker
      v-model="dateTimeRange"
      format="DD-MM-YYYY"
      type="date"
      valueType="timestamp"
      :open.sync="open"
      :lang="lang"
      :disabled-date="disableDate"
      :showSecond="false"
      :clearable="false"
      range
      @close="setDate"
    >
      <!-- <div slot="header">
        <clock-picker :value.sync="time" position="top" />
        <clock-picker :value.sync="time" position="top" />
      </div> -->
      <div slot="footer">
        <Button
          size="small"
          @click="confirm"
        >
          Подтвердить
        </Button>
      </div>
    </date-picker>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { utcToDate, dateToUtc, utcDateHasCome } from "@/utils/cdpUtils";
import DatePicker from 'vue2-datepicker';
import Button from '@/manzana_library/components/Elements/Button';
import dayjs from "dayjs";

export default {
  name: "DateTimeInput",

  components: {
    DatePicker,
    Button,
  },

  data() {
    return {
      open: false,
      dateTimeRange: null,
      time: "",
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
          months: ['январь', 'февраль', 'март', 'апрель', 'май', 'июнь', 'июль', 'август', 'сентябрь', 'октябрь', 'ноябрь', 'декабрь'],
          monthsShort: ['январь', 'февраль', 'март', 'апрель', 'май', 'июнь', 'июль', 'август', 'сентябрь', 'октябрь', 'ноябрь', 'декабрь'],
          weekdaysMin: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
        },
      },
    };
  },

  computed: {
    ...mapState({
      statDateRange: state => state.stat.statDateRange,
    }),
    utcDateHasCome() { // переносим для контекста, чтоб не надо было считать его.
    //  Значения -1,0,1 если локалка опережает, равна или отстает от UTC на 1 день соответственно
      return utcDateHasCome();
    },
  },

  mounted() {
    this.dateTimeRange = [utcToDate(this.statDateRange[0], false), utcToDate(this.statDateRange[1], false)];
    setTimeout(() => this.setText(), 100);
  },

  methods: {
    ...mapMutations({
      statMutation: "statMutation",
    }),

    confirm() {
      this.open = false;
      this.setDate();
    },

    disableDate(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      // т.к. utcDateHasCome возвращает -1, 0 или 1 в зависимости от "статуса" между локалкой и UTC
      // и это смещение единственно возможное, то воспользуемся им как количеством дней для смещения
      today.setDate(today.getDate() - this.utcDateHasCome);
      return (date > today) || (date < new Date(today.setFullYear(2018)));
    },

    setDate() {
      const val = this.dateTimeRange;
      const oldVal = this.statDateRange;

      if ( // вроде работает и применима для любого формата
        !val || !val[0] || !val[1] ||
        (dateToUtc(+val[0], true) === oldVal[0] && dateToUtc(+val[1], true) === oldVal[1])
      ) return;

      this.statMutation({
        key: "statDateRange",
        value: [dateToUtc(+val[0], false), dateToUtc(+val[1] + 86399000, false)],
      });

      setTimeout(() => this.setText());
    },

    setText() {
      const dateTextInput = document.querySelector(".mx-input");
      if (!dateTextInput) return;
      const value = this.constructPeriodText(dateTextInput.value);
      this.statMutation({
        key: "statDateText",
        value,
      });
    },
    constructPeriodText(period = '') { // не нашел как повлиять на текст непосрдественно с библиотечными инструментами, поэтому перелопачиваем так
      const periodArr = period.split(' ~ '); // period in format [date1, date2]
      const today = dayjs(today).format('DD-MM-YYYY');
      if (new Date(periodArr[1]) > new Date(today)) periodArr[1] = today; // преобразование 2 значений в таймстемп и сравнение, не может быть больше чем сегодня
      return periodArr.join(' ~ '); // возвращаем в том же формате, как и было
    },
  },
};
</script>

<style lang="scss">
$default-color: #373a3c;
$primary-color: #6c0;

@import '~vue2-datepicker/scss/index.scss';

.mx-input:focus, .mx-input:hover {
  border-color: $primary-color;
  & ~ .mx-icon-calendar svg path {
    fill: $primary-color;
  }
}

.tooltip {
  z-index: 2002 !important;
}

.mx-datepicker-footer {
  & > div {
    display: flex;
    justify-content: flex-end;
  }
}

.btn--timepanel {
  background: none;
  border-bottom: 2px solid $primary-color;
  border-radius: 0;
  font-size: 14px;
  text-align: left;
  padding: 0;
  margin-left: 5px;
  transition: all 0.3s ease;
  &:hover {
    border-color: $color_green-new;
  }
}
</style>
